import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./authentication/authSlice";
import coworkSlice from "./cowork/coworkSlice";
import userManagingSlice from "./userManagement/userManagingSlice";
import classroomSlice from "./classroom/classroomSlice";
import appModuleSlice from "./appModule/appModuleSlice";
import dashboardSlice from "./dashboard/dashboardSlice";

export const store = configureStore({
  reducer: {
    authentication: authSlice.reducer,
    coworkData:coworkSlice.reducer,
    management: userManagingSlice.reducer,
    classroomData: classroomSlice.reducer,
    appModule: appModuleSlice.reducer,
    dashboard: dashboardSlice.reducer,
  },
});
